import { useEffect, useState } from "react";
import { CommonForm } from "../../../Components/Common";

//TODO => Ensure the default fileds of the form are current project fileds.
const EditPopUp = ({
  onClose,
  setFormData,
  formData,
  onSave,
  renderFieldConfig,
  formLabelFields,
  readOnlyFields = [],
  isThreeColumnCSS,
}) => {
  const [localFormData, setLocalFormData] = useState(formData);
  const columnCSS = isThreeColumnCSS ? isThreeColumnCSS : "w-1/2 px-4";

  // Reset local data when any "schema" changes
  useEffect(() => {
    setLocalFormData(formData);
  }, [formData, renderFieldConfig, formLabelFields]);

  const handleChange = (name, value) => {
    setLocalFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    setFormData(localFormData);
    onSave(localFormData);
    onClose();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <div className="flex flex-col p-4 m-4 w-full max-w-3xl bg-white rounded-xl">
        <div className="text-center font-semibold text-md mb-4">
          Edit Details
        </div>
        <CommonForm
          formData={formData}
          renderField={renderFieldConfig}
          handleChangeData={handleChange}
          formFieldLabels={formLabelFields}
          isTwoColumnCss={columnCSS}
          readOnly={false}
          readOnlyFields={readOnlyFields}
        />
        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-1 rounded-lg bg-gray-200 hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 rounded-lg bg-blue-600 text-white hover:bg-blue-700"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditPopUp;
